import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    iphonex: false, // 是否为iphoneX以上机型
    wechat: false, // 是否为微信浏览器打开,
    hasNotch: false, // 是否安卓刘海屏
    headerTitle: '', // 标题：微信标题切换,
    hospitalizeId: '', // 住院号
    iphonexBottom: false,// 适配底部
    hospitalAuthList:[]
  },
  mutations: {
    changeIphoneX (state, val) {
      if (val) {
        state.iphonex = true
      } else {
        state.iphonex = false
      }
    },
    changeHasNotch (state, val) {
      if (val) {
        state.hasNotch = true
      } else {
        state.hasNotch = false
      }
    },
    changeIphoneXBottom (state, val) {
      if (val) {
        state.iphonexBottom = true
      } else {
        state.iphoneiphonexBottom = false
      }
    },
    changeWeChat (state, val) {
      if (val) {
        state.wechat = true
      } else {
        state.wechat = false
      }
    },
    changeHeaderTitle (state, val) {
      if (val) { state.headerTitle = val }
    },
    changeHospitalizeId (state, id) {
      state.hospitalizeId = id
    },
    changeHospitalAuthList(state, list) {
      state.hospitalAuthList = list
    },
  },
  getters: {
    getHeaderTitle (state) {
      return state.headerTitle
    },
    getHospitalizeCode (state) {
      return state.hospitalizeId
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js